
import { authHeader } from '../helpers';
import store from '@/store';

const userType = process.env.ROLE;

export const userService = {
  login,
  confirmEmail,
  getProfile,
  getAddress,
  getBankAccount,
  updateAddress,
  updateBankAccount,
  register,
  updateAccount,
  deleteAccount,
  resetPassword,
  requestResetPassword,
  verifyPersona,
};

// Account functions
function login(email, password, role) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, role }),
  };

  return fetch(`${process.env.ROOT_API}/user/login`, requestOptions).then(handleResponse);
}
function confirmEmail(token) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  };
  return fetch(`${process.env.ROOT_API}/user/confirm-email`, requestOptions).then(handleResponse);
}
function getProfile(id) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  const paramString = `${process.env.ROOT_API}/${userType}/${id}`;
  return fetch(paramString, requestOptions).then(handleResponse);
}
function getAddress(id) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  const paramString = `${process.env.ROOT_API}/${userType}/${id}/address`;
  return fetch(paramString, requestOptions).then(handleResponse);
}
function getBankAccount(id) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  const paramString = `${process.env.ROOT_API}/${userType}/${id}/bank-account`;
  return fetch(paramString, requestOptions).then(handleResponse);
}
function register(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data.form),
  };
  // Data also contains token for reCaptcha as data.token
  return fetch(`${process.env.ROOT_API}/user/register`, requestOptions).then(handleResponse);
}
function updateAccount(form, id) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/${userType}/${id}`, requestOptions).then(handleResponse);
}
function updateAddress({ address, id }) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(address),
  };
  return fetch(`${process.env.ROOT_API}/${userType}/${id}/address`, requestOptions).then(handleResponse);
}
function updateBankAccount({ form, id }) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/${userType}/${id}/bank-account`, requestOptions).then(handleResponse);
}
function deleteAccount() {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };

  return fetch(`${process.env.ROOT_API}/user`, requestOptions).then(handleResponse);
}
function verifyPersona(profileId, inquiryId) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({ inquiry_id: inquiryId }),
  };
  return fetch(`${process.env.ROOT_API}/artist/${profileId}/verify`, requestOptions).then(handleResponse);
}
function resetPassword(token, form) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/user/reset-password/?token=${token}`, requestOptions).then(handleResponse);
}
function requestResetPassword(form) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/user/reset-password`, requestOptions).then(handleResponse);
}

// Helper Functions
function handleResponse(response) {
  return response.text().then((text) => {
    const content = text && JSON.parse(text);
    if (!response.ok) {
      // Notify admin of issue
      // reportFault({ url: response.url, message: response.statusText });
      // auto logout if 401 response returned from api
      if (response.status === 401) {
        // INVALID USER GET HIM THE HELL OUT OF HERE!
        store.commit('account/logout');
        location.reload(true);
      }
      const error = (content && content.message) || response.statusText;
      return Promise.reject(error);
    }
    return Promise.resolve(content);
  });
}



// WEBPACK FOOTER //
// ./src/services/user.service.js